<template>
  <RouterLink v-slot="{ isActive, href, navigate }" v-bind="$props" custom>
    <a
      v-bind="$attrs"
      :href="href"
      :class="
        cn(
          variant == 'tab'
            ? 'navigation-item'
            : 'dropdown-item border-l-4 border-l-transparent',
          isActive ? activeClass : inactiveClass,
        )
      "
      @click="navigate">
      <slot />
    </a>
  </RouterLink>
</template>

<script setup lang="ts">
import { cn } from "@dpa-id-components/dpa-shared-components/src/utils/cn.ts";
import type { RouterLinkProps } from "vue-router";

defineOptions({
  inheritAttrs: false,
});

interface CvdNavigationRouterLinkProps extends RouterLinkProps {
  inactiveClass?: string;
  variant?: "tab" | "dropdown";
}

const { inactiveClass = "", variant = "tab" } =
  defineProps<CvdNavigationRouterLinkProps>();
</script>
